import React from 'react';
import RegisterComponent from '@/views/auth/register/Register.component';

export default function RegisterModalView() {
  const referenceCode = localStorage.getItem('referenceCode');
  return (
    <div className='sm:w-96'>
      {/*<RegisterView referenceCode={referenceCode} />*/}
      <RegisterComponent />
    </div>
  );
}
